import { useState } from 'react';
import Header from '../../components/navigation/Header';
import HeroSection from './components/HeroSection';
import ServiceCategoriesSection from './components/ServiceCategoriesSection';
import JobsAndProvidersSection from './components/JobsAndProvidersSection';
import HowItWorksSection from './components/HowItWorksSection';
import Footer from './components/Footer';

const HomeLanding = () => {
  const [searchParams, setSearchParams] = useState(null);

  const handleSearch = (params) => {
    setSearchParams(params);
    console.log('Search parameters:', params);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="pt-[60px] lg:pt-[60px]">
        <HeroSection onSearch={handleSearch} />
        <ServiceCategoriesSection />
        <JobsAndProvidersSection />
        <HowItWorksSection />
      </main>

      <Footer />
    </div>
  );
};

export default HomeLanding;